var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.63438 7.76559C2.4844 7.61557 2.40015 7.41212 2.40015 7.19999C2.40015 6.98786 2.4844 6.78441 2.63438 6.63439L7.43438 1.83439C7.5844 1.68441 7.78784 1.60016 7.99998 1.60016C8.21211 1.60016 8.41555 1.68441 8.56558 1.83439L13.3656 6.63439C13.5113 6.78527 13.5919 6.98735 13.5901 7.19711C13.5883 7.40687 13.5042 7.60752 13.3558 7.75584C13.2075 7.90417 13.0069 7.9883 12.7971 7.99013C12.5873 7.99195 12.3853 7.91131 12.2344 7.76559L8.79998 4.33119V13.6C8.79998 13.8122 8.71569 14.0156 8.56566 14.1657C8.41563 14.3157 8.21215 14.4 7.99998 14.4C7.7878 14.4 7.58432 14.3157 7.43429 14.1657C7.28426 14.0156 7.19998 13.8122 7.19998 13.6V4.33119L3.76558 7.76559C3.61555 7.91556 3.41211 7.99982 3.19998 7.99982C2.98784 7.99982 2.7844 7.91556 2.63438 7.76559Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/ArrowUp.789e6d09e49edd1ba6ae2d511f5aac9a.svg";
export { ForwardRef as ReactComponent };